import { render } from "./AboutPage.vue?vue&type=template&id=db209f12"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=db209f12&lang=css"
script.render = render

export default script